import BrandmisuseSearchService from '../services/brandmisuse-search-service';

export const brandmisuseSearch = {
  namespaced: true,
  state: {
    funnelData: null,
    searchResult: null,
    pageNumber: 0,
    lastSearchConfig: null,
    brandmisuseFollowUpDateCount: null
  },
  actions: {
    getFunnelData({ commit }) {
      commit('setIsBusy', true, { root: true });
      commit('setFunnelData', null);
      return BrandmisuseSearchService.getFunnelData().then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setFunnelData', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    getFunnelDataForYear({ commit }, yearNumber) {
      commit('setIsBusy', true, { root: true });
      commit('setFunnelData', null);
      return BrandmisuseSearchService.getFunnelDataForYear(yearNumber).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setFunnelData', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    executeLastSearch({ dispatch, state }) {
      if (!state.lastSearchConfig) {
        throw new Error('No brandmisuse search has been run yet - cannot rerun');
      }
      dispatch('searchBrandmisuse', state.lastSearchConfig).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    searchBrandmisuse({ commit }, data) {
      data.type = 'standard';
      commit('setLastSearchConfig', data);
      return BrandmisuseSearchService.search(data).then(
        (result) => {
          commit('setBrandmisuseSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    searchBrandmisuseAdvanced({ commit }, data) {
      data.type = 'advanced';
      commit('setLastSearchConfig', data);
      return BrandmisuseSearchService.advancedSearch(data).then(
        (result) => {
          commit('setBrandmisuseSearchResult', result);
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getBrandmisuseFollowUpDateCount({ commit }) {
      return BrandmisuseSearchService.getBrandmisuseFollowUpDateCount()
        .then((result) => {
          commit('setBrandmisuseFollowUpDateCount', result.brandMisuseFollowUpDateCount);
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    removeBrandmisuseFromSearchResult(state, disputeId) {
      if (state.searchResult) {
        const removed = state.searchResult.results.find((x) => x.disputeId === disputeId);
        if (removed) {
          const newSearchResult = state.searchResult.results.filter(
            (x) => x.disputeId !== removed.disputeId
          );
          state.searchResult = newSearchResult;
        }
      }
    },
    setBrandmisuseSearchResult(state, searchResult) {
      state.searchResult = searchResult;
    },
    setLastSearchConfig(state, searchconfig) {
      state.lastSearchConfig = searchconfig;
    },
    setSearchPageNumber(state, newPageNumber) {
      state.pageNumber = newPageNumber;
    },
    setFunnelData(state, newData) {
      state.funnelData = newData;
    },
    setBrandmisuseFollowUpDateCount(state, newState) {
      state.brandmisuseFollowUpDateCount = newState;
    }
  },
};
